import React, { useEffect, useState } from "react";
import { apiGet } from "../utils/api";

export default function LowStockAlerts({ compact = false }) {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const result = await apiGet("/api/shop/low-stock");
        setProducts(Array.isArray(result?.products) ? result.products : []);
      } catch (err) {
        setError(err?.message || "Failed to load low stock alerts");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Low Stock Alerts</h3>
        <div className="animate-pulse space-y-3">
          <div className="h-4 bg-gray-200 rounded w-full" />
          <div className="h-4 bg-gray-200 rounded w-5/6" />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Low Stock Alerts</h3>
        <p className="text-sm text-red-600">{error}</p>
      </div>
    );
  }

  const displayProducts = compact ? products.slice(0, 5) : products;

  return (
    <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Low Stock Alerts</h3>
        {products.length > 0 && (
          <span className="bg-orange-100 text-orange-800 text-xs font-semibold px-2.5 py-1 rounded-full">
            {products.length}
          </span>
        )}
      </div>

      {products.length === 0 ? (
        <div className="text-sm text-gray-500">
          ✓ All products have sufficient stock
        </div>
      ) : (
        <>
          <div className="space-y-2">
            {displayProducts.map((product) => (
              <div
                key={product._id || product.id}
                className="flex items-center justify-between p-3 bg-orange-50 rounded-lg border border-orange-200"
              >
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-gray-900 truncate">
                    {product.title || product.name || "Unnamed Product"}
                  </div>
                  <div className="text-xs text-gray-600 mt-1">
                    Stock: {product.stock || 0} / Threshold: {product.lowStockThreshold || 10}
                  </div>
                </div>
                <a
                  href={`/shop/products`}
                  className="ml-3 text-xs font-medium text-orange-600 hover:text-orange-700 whitespace-nowrap"
                >
                  Restock →
                </a>
              </div>
            ))}
          </div>

          {compact && products.length > 5 && (
            <div className="mt-4 pt-4 border-t border-gray-200">
              <a
                href="/shop/low-stock"
                className="text-sm font-medium text-blue-600 hover:text-blue-700"
              >
                View all {products.length} alerts →
              </a>
            </div>
          )}
        </>
      )}
    </div>
  );
}
